import React from "react";
import tw from "twin.macro";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

const Container = tw.div`relative mx-auto md:px-8 py-6 max-w-screen-xl`;

export default () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Alert severity="info">
        {t("contact-us.header_title_01")} <br />{" "}
        {t("contact-us.header_title_02")}
      </Alert>
    </Container>
  );
};
